import { render, staticRenderFns } from "./ExpenseAnalysis.vue?vue&type=template&id=4613924b&scoped=true"
import script from "./ExpenseAnalysis.vue?vue&type=script&lang=js"
export * from "./ExpenseAnalysis.vue?vue&type=script&lang=js"
import style0 from "./ExpenseAnalysis.vue?vue&type=style&index=0&id=4613924b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4613924b",
  null
  
)

export default component.exports